import {
    FullPageLoading,
} from "@mrflark/ui";
import type {
    ComponentChildren,
} from "preact";
import {
    Navigate,
} from "react-router-dom";
import {
    useAuthStore,
} from "../../stores/authStore.ts";

type PermissionCheck =
    | "can_tag"
    | "can_delete"
    | "can_hard_delete"
    | "can_manage";

type ProtectedRouteProps = {
    children: ComponentChildren;
    requiredPermission?: PermissionCheck;
};

export const ProtectedRoute = ({
    children,
    requiredPermission,
}: ProtectedRouteProps) => {
    const {
        isAuthenticated,
        isLoading,
        canTag,
        canDelete,
        canHardDelete,
        canManage,
    } = useAuthStore();

    if (isLoading || !isAuthenticated) {
        return <FullPageLoading />;
    }

    if (requiredPermission) {
        const permissionChecks: Record<PermissionCheck, () => boolean> = {
            can_tag: canTag,
            can_delete: canDelete,
            can_hard_delete: canHardDelete,
            can_manage: canManage,
        };

        const hasPermission = permissionChecks[requiredPermission]();
        if (!hasPermission) {
            return <Navigate to="/" replace />;
        }
    }

    return <>{children}</>;
};
